import styles from "./index.module.scss";
import { Col, Row } from "antd";
import MainTitle from "@/components/MainTitle";
import codeUrl from "@/assets/images/home/code.jpg";
import wxUrl from "@/assets/images/community/subscription.png";
import qqUrl from "@/assets/images/community/qq.png";
import intl from "react-intl-universal";
import classNames from "classnames";

const Together = () => {
  return (
    <div className={classNames("container",styles.togetherWrap)}>
      <Row gutter={100} justify="center">
        <Col
          span={9}
          offset={3}
          className="wow animate__fadeInLeft"
          data-wow-duration="1s"
        >
          <div className={styles.contentBox}>
            <MainTitle title="community.Follow the WeChat Account" />
            <div className={styles.textBox}>
              {intl.get("community.Scan to Follow the OGE Official WeChat Account")}
            </div>
          </div>
        </Col>
        <Col
          span={10}
          offset={2}
          className="wow animate__fadeInRight"
          data-wow-duration="1s"
        >
          <div className={styles.imgBox}>
            <img src={wxUrl} />
          </div>
        </Col>
      </Row>

      <Row gutter={100} style={{ marginTop: "60px" }}  justify="center">
      <Col
           span={9}
           offset={3}
          className="wow animate__fadeInRight"
          data-wow-duration="1s"
        >
          <div className={styles.contentBox}>
            <MainTitle title="community.Join the QQ Group (Chinese)" />
            <div className={styles.textBox}>
              {intl.get("community.Scan to Join the QQ Group (Chinese)")}
            </div>
          </div>
        </Col>
        <Col
           span={10}
           offset={2}
          className="wow animate__fadeInLeft"
          data-wow-duration="1s"
        >
          <div className={styles.imgBox}>
            <img src={qqUrl} />
          </div>
        </Col>
       
      </Row>
    </div>
  );
};
export default Together;
